import { render, staticRenderFns } from "./best-match-detail.vue?vue&type=template&id=11708846&"
import script from "./best-match-detail.vue?vue&type=script&lang=js&"
export * from "./best-match-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports